// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'heart-solid';

export const Component = () => (
  <path d='M24.522 7.848c0 1.389-.383 2.825-1.198 4.406-.815 1.58-1.724 2.97-2.682 4.071-1.005 1.102-2.155 2.3-3.544 3.496-1.388 1.197-2.299 2.012-2.778 2.347-.526.335-1.005.719-1.484 1.054l-.575.335-.575-.383c-.479-.335-.958-.719-1.437-1.054-.526-.335-1.437-1.149-2.826-2.347a34.318 34.318 0 0 1-3.496-3.496c-1.005-1.101-1.868-2.442-2.682-4.022C.431 10.675 0 9.237 0 7.848c0-2.059.575-3.687 1.772-4.98C2.922 1.623 4.454 1 6.37 1c2.107 0 4.07 1.102 5.89 3.305C14.08 2.102 16.044 1 18.15 1c1.916 0 3.45.623 4.646 1.868 1.15 1.293 1.724 2.921 1.724 4.98h.002Z' />
);

export const viewBox = '0 0 25 25';
